import {
  AdjustFeatures,
  AdjustTerms,
  ToolkitStudyV1Request,
  adjustTermToFeature,
} from '@aloft/toolkit-shared';

import { startCase } from 'lodash';

import { isPairedSalesCustomAnalysisFeature } from '../../adjustPairedSalesStandalone/utils/isPairedSalesCustomAnalysisFeature.ts';

const getPrefix = (analysisFeature: ToolkitStudyV1Request['analysisFeature']): string => {
  if (analysisFeature === 'totalBasementArea') return 'Basement';
  if (analysisFeature === 'carportParkingSpacesCount') return 'Carport ';
  if (analysisFeature === 'garageParkingSpacesCount') return 'Garage ';
  if (analysisFeature === 'grossLivingArea') return 'GLA';
  if (analysisFeature === 'site') return 'Lot';

  return '';
};

export const getAnalysisFeatureUnitString = (
  analysisFeature: ToolkitStudyV1Request['analysisFeature'],
): string => {
  if (isPairedSalesCustomAnalysisFeature(analysisFeature)) return analysisFeature.name;

  const feature = adjustTermToFeature(analysisFeature);
  const unit =
    (feature && AdjustFeatures[feature].unit) ?? AdjustTerms[analysisFeature].label ?? 'unit';
  const prefix = getPrefix(analysisFeature);

  if (
    analysisFeature === 'totalBasementArea' ||
    analysisFeature === 'grossLivingArea' ||
    analysisFeature === 'site'
  ) {
    return `${startCase(unit)} ${prefix}`;
  }

  return startCase(`${prefix}${unit}`);
};
